import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import HomePage from "./Pages/HomePage";
import SignUpPage from "./Pages/SignUpPage";
import LoginPage from "./Pages/LoginPage";
import LeaderboardPage from "./Pages/LeaderboardPage";
import FaqPage from "./Pages/FaqPage";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import BarChartIcon from "@material-ui/icons/BarChart";
import Modal from "@material-ui/core/Modal";

import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import { getFromStorage, setInStorage } from "./utils/storage";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    display: "flex",
    justifyContent: "space-between",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
}));

function App() {
  const classes = useStyles();

  const [loggedIn, setLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const [signUpModal, setSignUpModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);

  const logout = () => {
    console.log("Attemoting to logout");
    const tokenInStorage = getFromStorage("bbexchange");
    console.log(tokenInStorage);
    if (tokenInStorage != null) {
      console.log("Fetch");
      fetch(
        "https://bb-exchange.herokuapp.com/api/account/logout?token=" +
          tokenInStorage
      )
        .then((res) => res.json())
        .then((json) => {
          console.log(json);
          if (json.success) {
            setToken(null);
            setInStorage("bbexchange", null);
            setLoggedIn(false);
          }
        });
    }
  };

  const updateToken = (t) => {
    setLoggedIn(true);
    setToken(t);
    setInStorage("bbexchange", t);
    setSignUpModal(false);
    setLoginModal(false);
  };

  useEffect(() => {
    const tokenInStorage = getFromStorage("bbexchange");
    setToken(tokenInStorage);
    if (tokenInStorage) {
      fetch(
        "https://bb-exchange.herokuapp.com/api/account/verify?token=" +
          tokenInStorage
      )
        .then((res) => res.json())
        .then((json) => {
          console.log(json);
          if (json.success) {
            setToken(tokenInStorage);
            setLoggedIn(true);
          } else {
            setLoggedIn(false);
            setToken(null);
          }
        });
    } else {
      setLoggedIn(false);
      setToken(null);
    }
  }, []);

  return (
    <div className={classes.root}>
      <CssBaseline />

      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" noWrap>
            Big Brother All Stars Exchange
          </Typography>
          {!loggedIn ? (
            <div>
              <Button
                style={{ color: "white" }}
                onClick={() => setLoginModal(true)}
              >
                Login
              </Button>
              <Button
                style={{ color: "white" }}
                onClick={() => setSignUpModal(true)}
              >
                Signup
              </Button>
            </div>
          ) : (
            <Button style={{ color: "white" }} onClick={logout}>
              Logout
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.toolbar} />
        <Divider />
        <List>
          <ListItem
            button
            onClick={() => {
              window.location = "/";
            }}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              window.location = "/leaderboard";
            }}
            n
          >
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary={"Leaderboard"} />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              window.location = "/faq";
            }}
            n
          >
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary={"FAQ"} />
          </ListItem>
        </List>
      </Drawer>
      <Modal
        open={signUpModal}
        onClose={() => setSignUpModal(false)}
        aria-labelledby="Sign Up"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SignUpPage setToken={(t) => updateToken(t)} />
      </Modal>
      <Modal
        open={loginModal}
        onClose={() => setLoginModal(false)}
        aria-labelledby="Login"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoginPage setToken={(t) => updateToken(t)} />
      </Modal>
      <div className={classes.content}>
        <div className={classes.toolbar} />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />

        <Router>
          <Route exact path="/" component={() => <HomePage token={token} />} />
          <Route exact path="/signup" component={() => <SignUpPage />} />
          <Route
            exact
            path="/leaderboard"
            component={() => <LeaderboardPage />}
          />
          <Route exact path="/faq" component={() => <FaqPage />} />
        </Router>
      </div>
    </div>
  );
}

export default App;
